import React, { useState } from 'react';
import { Heart, ShoppingCart, Download, Check, Loader } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import "./style.css"

const ButtonShowcase = () => {
  const { t } = useTranslation('design');
  const [likeCount, setLikeCount] = useState(42);
  const [isLiked, setIsLiked] = useState(false);
  const [cartItems, setCartItems] = useState(0);
  const [downloadState, setDownloadState] = useState('idle');

  const handleLike = () => {
    setIsLiked(!isLiked);
    setLikeCount(prev => isLiked ? prev - 1 : prev + 1);
  };

  const handleAddToCart = () => {
    setCartItems(prev => prev + 1);
  };

  const handleDownload = () => {
    setDownloadState('loading');
    setTimeout(() => {
      setDownloadState('success');
      setTimeout(() => setDownloadState('idle'), 2000);
    }, 1500);
  };

  return (
    <div className="button-showcase">
      <button
        className={`btnBento interactive-btn like-button ${isLiked ? 'liked' : ''}`}
        onClick={handleLike}
      >
        <Heart size={16} fill={isLiked ? '#ff7025' : 'none'} />
        <span>{likeCount}</span>
      </button>

      <button
        className="btnBento interactive-btn cart-button"
        onClick={handleAddToCart}
      >
        <ShoppingCart size={16} />
        <span>{t('buttonShowcase.addToCart')}</span>
        {cartItems > 0 && <span className="cart-badge">{cartItems}</span>}
      </button>

      <button
        className={`btnBento interactive-btn download-btn ${downloadState}`}
        onClick={handleDownload}
        disabled={downloadState === 'loading'}
      >
        {downloadState === 'idle' && <Download size={16} />}
        {downloadState === 'loading' && <Loader size={16} className="spinning" />}
        {downloadState === 'success' && <Check size={16} />}
        <span>
          {downloadState === 'idle' && t('buttonShowcase.download')}
          {downloadState === 'loading' && t('buttonShowcase.downloading')}
          {downloadState === 'success' && t('buttonShowcase.downloaded')}
        </span>
      </button>
    </div>
  );
};

export default ButtonShowcase;